import React, { useEffect } from "react";
import { Box, Button, Typography } from "@mui/material";
import "./VivaExam.css";

export const SubmitSuccessPopup = ({ onClose, autoClose }) => {
  // Auto close after 2 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      autoClose();
    }, 5000);
    return () => clearTimeout(timer);
  }, [autoClose]);

  return (
    <Box
      className="success-popup-content"
    >
      <Box sx={{ fontSize: 60, color: "var(--brand)" }}>
        <i className="fa fa-check-circle"></i>
      </Box>
      <Typography sx={{ fontSize: 22, fontWeight: 600 }}>
        Successfully Submitted!
      </Typography>
      <Typography sx={{ fontSize: 16, color: "#555", mb: 2 }}>
        Your responses have been saved and submitted.
      </Typography>
      <Button
        className="save-modal-button"
        onClick={onClose}
        fullWidth={{ xs: true, sm: false }}
        sx={{
          background: "linear-gradient(135deg, #f79033, #f05a6e)",
          color: "#fff",

          px: { xs: 2, sm: 4 },
          py: { xs: 1.2, sm: 1.5 },

          fontSize: { xs: "14px", sm: "16px" },
          borderRadius: { xs: "10px", sm: "12px" },

          minHeight: { xs: 44, sm: 48 },

          "&:hover": {
            opacity: 0.95,
          },

          "&:active": {
            transform: "scale(0.98)",
          },
        }}
      >
        Close
      </Button>

    </Box>
  );
};
